<template>
  <div>
    <app-bar ref="refAppBar" @updated="updated"></app-bar>
    <v-card elevation="0">
      <v-card-title>
        <v-container fluid>
          <v-row align="center">
            <v-col cols="12" sm="3">
              <v-select
                :items="active_status"
                v-model="condition.is_active"
                label="ステータス"
                @change="changeCondition"
                hide-details
                dense
              ></v-select>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="（キーワード検索）"
                single-line
                hide-details
                clearable
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
      <!-- テーブル -->
      <v-data-table
        :headers="headers"
        :items="desserts"
        :search="search"
        item-key="id"
        :mobile-breakpoint="0"
        :items-per-page="100"
        :footer-props="{
          'items-per-page-options': [100, 200, 400, -1],
          'items-per-page-text': '表示件数',
        }"
      >
        <!-- eslint-disable-next-line -->
        <template v-slot:footer.page-text="props">
          {{ props.pageStart }} ～{{ props.pageStop }}件／全{{
            props.itemsLength
          }}件
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.edit="{ item }">
          <v-icon class="pa-1" @click="editItem(item)"> mdi-pencil </v-icon>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.address="{ item }">
          {{ formatAddress(item) }}
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.website="{ item }">
          <a v-if="item.website" :href="item.website" target="_blank">{{
            item.website
          }}</a>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.is_active="{ item }">
          <div class="pa-1">
            <v-chip
              v-if="item.is_active"
              class="ma-2"
              color="primary"
              label
              small
            >
              有効
            </v-chip>
            <v-chip v-else class="ma-2" label small> 削除済 </v-chip>
          </div>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.contact="{ item }">
          <v-icon
            class="pa-1"
            @click="contactItem(item)"
            :disabled="!item.is_active"
          >
            mdi-account-multiple
          </v-icon>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.delete="{ item }">
          <v-icon
            class="pa-1"
            @click="deleteItem(item)"
            :disabled="!item.is_active"
          >
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:no-data> 表示するデータがありません </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { ref, reactive, toRefs, defineComponent } from "@vue/composition-api";
import { repositoryFactory } from "@/repository/repositoryFactory";
import store from "@/store/index.js";
import setting from "@/common/setting.js";
import appBar from "./appBar.vue";
import router from "@/router/index";

export default defineComponent({
  components: {
    appBar,
  },
  setup(_, ctx) {
    const agenciesRepository = repositoryFactory.get("agencies");
    const refAppBar = ref();
    const state = reactive({
      search: "",
      headers: [
        {
          text: "編集",
          value: "edit",
          sortable: false,
          align: "center",
          width: 60,
        },
        {
          text: "法人名",
          value: "name",
          sortable: true,
          class: "td_name",
        },
        {
          text: "住所",
          value: "address",
          sortable: false,
          class: "td_address",
        },
        {
          text: "代表番号",
          value: "tel",
          sortable: true,
          class: "td_tel",
        },
        {
          text: "ホームページ",
          value: "website",
          sortable: false,
          class: "td_website",
        },
        {
          text: "メモ",
          value: "note",
          sortable: true,
          class: "td_note",
        },
        {
          text: "ステータス",
          value: "is_active",
          sortable: false,
          align: "center",
        },
        {
          text: "担当者",
          value: "contact",
          sortable: false,
          align: "center",
          width: 60,
        },
        {
          text: "削除",
          value: "delete",
          sortable: false,
          align: "center",
          width: 60,
        },
      ],
      desserts: [], // DataTablesレコード格納用
      condition: {
        is_active: true,
      },
    });

    const active_status = [
      { value: null, text: "未選択" },
      { value: true, text: "有効" },
      { value: false, text: "削除済" },
    ];

    const editItem = (agency) => {
      // ダイアログ開く
      refAppBar.value.action({
        action: "edit",
        value: agency.id,
      });
    };

    // 担当者画面に遷移
    const contactItem = async (item) => {
      await router.push({
        name: "admin-agency-contact",
        params: {
          agency_id: item.id,
        },
      });
    };

    // データ削除
    const deleteItem = async (item) => {
      if (window.confirm("削除してよろしいですか？")) {
        store.dispatch("loadingIcon/showIcon"); // ローディング表示

        // 削除処理
        await agenciesRepository
          .admin_delete(item.id)
          .then((response) => {
            if (response.data) {
              // データ削除OK
              alert(`「${item.name}」が削除されました。`);
            }
          })
          .catch((error) => {
            throw (
              "ERROR:admin/agency/index.vue/deleteItem agenciesRepository.admin_delete (" +
              error +
              ")"
            );
          });

        init();

        store.dispatch("loadingIcon/hideIcon"); // ローディング非表示
      }
    };

    const formatAddress = (item) => {
      const zip = item.zip_code ? `〒${item.zip_code} ` : "";
      const a1 = item.address1 || "";
      const a2 = item.address2 || "";
      return `${zip}${a1}${a2}`.trim();
    };

    // 初期化処理(同期処理)
    const init = async () => {
      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      // リクエストパラメータ組立て
      // is_activeが未選択(null)の場合は、削除済を含む全件取得のためinclude_deletedを送信
      const params = {};
      if (state.condition.is_active === null) {
        params.include_deleted = true;
      } else {
        params.is_active = state.condition.is_active;
      }

      state.desserts.splice(0);
      await agenciesRepository
        .admin_list(params)
        .then((response) => {
          if (response.data) {
            Object.keys(response.data).forEach(function (key) {
              state.desserts.push(response.data[key]);
            });
          }
        })
        .catch((error) => {
          throw (
            "ERROR:admin/agency/index.vue/init agenciesRepository.admin_list (" +
            error +
            ")"
          );
        });

      store.dispatch("loadingIcon/hideIcon"); // ローディング非表示
    };

    init();

    const updated = () => {
      init();
    };

    const changeCondition = () => {
      init();
    };

    // 返却オブジェクト定義
    return {
      refAppBar,
      setting,
      active_status,
      ...toRefs(state),
      editItem,
      contactItem,
      deleteItem,
      init,
      updated,
      changeCondition,
      formatAddress,
    };
  },
});
</script>
<style scoped>
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  padding: 0 6px !important;
}
::v-deep .td_name {
  min-width: 150px;
  width: 250px;
}
::v-deep .td_tel {
  min-width: 110px;
  width: 140px;
}
::v-deep .td_website {
  min-width: 150px;
}
::v-deep .td_address {
  min-width: 200px;
}
::v-deep .td_note {
  min-width: 150px;
}
</style>
